export const apiFootballLeagues = [
    {
        id: 1,
        name: 'Copa del Mundo',
    },
    {
        id: 2,
        name: 'Champions League',
        slug: 'champions-league',
    },
    {
        id: 3,
        name: 'Europa League',
        slug: 'europa-league',
    },
    {
        id: 4,
        name: 'Euro Championship',
    },
    {
        id: 5,
        name: 'Nations League',
    },
    {
        id: 6,
        name: 'Copa África de Naciones',
    },
    {
        id: 7,
        name: 'Copa Asia',
    },
    {
        id: 8,
        name: 'Copa del Mundo Femenina',
    },
    {
        id: 9,
        name: 'Copa América',
    },
    {
        id: 10,
        name: 'Amistosos de selecciones',
    },
    {
        id: 11,
        name: 'CONMEBOL Sudamericana',
    },
    {
        id: 12,
        name: 'CAF Champions League',
    },
    {
        id: 13,
        name: 'CONMEBOL Libertadores',
    },
    {
        id: 14,
        name: 'UEFA Youth League',
    },
    {
        id: 15,
        name: 'FIFA Club World Cup',
    },
    {
        id: 16,
        name: 'CONCACAF Champions League',
    },
    {
        id: 17,
        name: 'AFC Champions League',
    },
    {
        id: 18,
        name: 'AFC Cup',
    },
    {
        id: 19,
        name: 'African Nations Championship',
    },
    {
        id: 20,
        name: 'CAF Confederation Cup',
    },
    {
        id: 21,
        name: 'Confederations Cup',
    },
    {
        id: 22,
        name: 'CONCACAF Gold Cup',
    },
    {
        id: 23,
        name: 'EAFF E-1 Football Championship',
    },
    {
        id: 24,
        name: 'AFF Championship',
    },
    {
        id: 25,
        name: 'Gulf Cup of Nations',
    },
    {
        id: 26,
        name: 'International Champions Cup',
    },
    {
        id: 27,
        name: 'OFC Champions League',
    },
    {
        id: 28,
        name: 'SAFF Championship',
    },
    {
        id: 29,
        name: 'World Cup - Qualification Africa',
    },
    {
        id: 30,
        name: 'World Cup - Qualification Asia',
    },
    {
        id: 31,
        name: 'World Cup - Qualification CONCACAF',
    },
    {
        id: 32,
        name: 'World Cup - Qualification Europe',
    },
    {
        id: 33,
        name: 'World Cup - Qualification Oceania',
    },
    {
        id: 34,
        name: 'World Cup - Qualification South America',
    },
    {
        id: 35,
        name: 'Asian Cup - Qualification',
    },
    {
        id: 36,
        name: 'Africa Cup of Nations - Qualification',
    },
    {
        id: 37,
        name: 'World Cup - Qualification Intercontinental Play-offs',
    },
    {
        id: 38,
        name: 'UEFA U21 Championship',
    },
    {
        id: 39,
        name: 'Premier League Inglaterra',
        slug: 'premier-league',
    },
    {
        id: 40,
        name: 'Championship (Inglaterra 2da división)',
    },
    {
        id: 41,
        name: 'League One',
    },
    {
        id: 42,
        name: 'League Two',
    },
    {
        id: 43,
        name: 'National League',
    },
    {
        id: 44,
        name: 'FA WSL',
    },
    {
        id: 45,
        name: 'FA Cup',
    },
    {
        id: 46,
        name: 'EFL Trophy',
    },
    {
        id: 47,
        name: 'FA Trophy',
    },
    {
        id: 48,
        name: 'League Cup',
    },
    {
        id: 49,
        name: 'National League - Play-offs',
    },
    {
        id: 50,
        name: 'National League - North',
    },
    {
        id: 51,
        name: 'National League - South',
    },
    {
        id: 52,
        name: 'Non League Div One - Isthmian North',
    },
    {
        id: 53,
        name: 'Non League Div One - Isthmian South Central',
    },
    {
        id: 54,
        name: 'Non League Div One - Northern West',
    },
    {
        id: 55,
        name: 'Non League Div One - Northern Midlands',
    },
    {
        id: 56,
        name: 'Non League Div One - Southern South',
    },
    {
        id: 57,
        name: 'Non League Div One - Isthmian South East',
    },
    {
        id: 58,
        name: 'Non League Premier - Isthmian',
    },
    {
        id: 59,
        name: 'Non League Premier - Northern',
    },
    {
        id: 60,
        name: 'Non League Premier - Southern South',
    },
    {
        id: 61,
        name: 'Ligue 1 (Francia 1era división)',
    },
    {
        id: 62,
        name: 'Ligue 2 (Francia 2da división)',
    },
    {
        id: 63,
        name: 'National 1',
    },
    {
        id: 64,
        name: 'Feminine Division 1',
    },
    {
        id: 65,
        name: 'Coupe de la Ligue',
    },
    {
        id: 66,
        name: 'Coupe de France',
    },
    {
        id: 67,
        name: 'National 2 - Group A',
    },
    {
        id: 68,
        name: 'National 2 - Group B',
    },
    {
        id: 69,
        name: 'National 2 - Group C',
    },
    {
        id: 70,
        name: 'National 2 - Group D',
    },
    {
        id: 71,
        name: 'Serie A (Brasil 1era división)',
    },
    {
        id: 72,
        name: 'Serie B (Brasil 2da división)',
    },
    {
        id: 73,
        name: 'Copa Do Brasil (Brasil)',
    },
    {
        id: 74,
        name: 'Brasileiro Women',
    },
    {
        id: 75,
        name: 'Serie C (Brasil 3era división)',
    },
    {
        id: 76,
        name: 'Serie D (Brasil 4ta división)',
    },
    {
        id: 77,
        name: 'Alagoano',
    },
    {
        id: 78,
        name: 'Bundesliga (Alemania 1era división)',
    },
    {
        id: 79,
        name: '2. Bundesliga (Alemania 2da división)',
    },
    {
        id: 80,
        name: '3. Liga',
    },
    {
        id: 81,
        name: 'DFB Pokal',
    },
    {
        id: 82,
        name: 'Frauen Bundesliga',
    },
    {
        id: 83,
        name: 'Regionalliga - Bayern',
    },
    {
        id: 84,
        name: 'Regionalliga - Nord',
    },
    {
        id: 85,
        name: 'Regionalliga - Nordost',
    },
    {
        id: 86,
        name: 'Regionalliga - SudWest',
    },
    {
        id: 87,
        name: 'Regionalliga - West',
    },
    {
        id: 88,
        name: 'Eredivisie',
    },
    {
        id: 89,
        name: 'Eerste Divisie',
    },
    {
        id: 90,
        name: 'KNVB Beker',
    },
    {
        id: 91,
        name: 'Eredivisie Women',
    },
    {
        id: 92,
        name: 'Derde Divisie - Saturday',
    },
    {
        id: 93,
        name: 'Derde Divisie - Sunday',
    },
    {
        id: 94,
        name: 'Primeira Liga',
    },
    {
        id: 95,
        name: 'Segunda Liga',
    },
    {
        id: 96,
        name: 'Taça de Portugal',
    },
    {
        id: 97,
        name: 'Taça da Liga',
    },
    {
        id: 98,
        name: 'J1 League',
    },
    {
        id: 99,
        name: 'J2 League',
    },
    {
        id: 100,
        name: 'J3 League',
    },
    {
        id: 101,
        name: 'J-League Cup',
    },
    {
        id: 102,
        name: 'Emperor Cup',
    },
    {
        id: 103,
        name: 'Eliteserien',
    },
    {
        id: 104,
        name: '1. Division',
    },
    {
        id: 105,
        name: 'NM Cupen',
    },
    {
        id: 106,
        name: 'Ekstraklasa',
    },
    {
        id: 107,
        name: 'I Liga',
    },
    {
        id: 108,
        name: 'Cup',
    },
    {
        id: 109,
        name: 'II Liga - East',
    },
    {
        id: 110,
        name: 'Premier League',
    },
    {
        id: 111,
        name: 'FAW Championship',
    },
    {
        id: 112,
        name: 'Welsh Cup',
    },
    {
        id: 113,
        name: 'Allsvenskan',
    },
    {
        id: 114,
        name: 'Superettan',
    },
    {
        id: 115,
        name: 'Svenska Cupen',
    },
    {
        id: 116,
        name: 'Premier League',
    },
    {
        id: 117,
        name: '1. Division',
    },
    {
        id: 118,
        name: '2. Division',
    },
    {
        id: 119,
        name: 'Superliga',
    },
    {
        id: 120,
        name: '1. Division',
    },
    {
        id: 121,
        name: 'DBU Pokalen',
    },
    {
        id: 122,
        name: '2nd Division - Group 1',
    },
    {
        id: 123,
        name: '2nd Division - Group 2',
    },
    {
        id: 124,
        name: 'Denmark Series - Group 1',
    },
    {
        id: 125,
        name: 'Denmark Series - Group 2',
    },
    {
        id: 126,
        name: 'Denmark Series - Group 3',
    },
    {
        id: 127,
        name: 'Denmark Series - Group 4',
    },
    {
        id: 128,
        name: 'Liga Profesional Argentina',
    },
    {
        id: 129,
        name: 'Primera Nacional',
    },
    {
        id: 130,
        name: 'Copa Argentina',
    },
    {
        id: 131,
        name: 'Primera B Metropolitana',
    },
    {
        id: 132,
        name: 'Primera C',
    },
    {
        id: 133,
        name: 'Primera D',
    },
    {
        id: 134,
        name: 'Torneo Federal A',
    },
    {
        id: 135,
        name: 'Serie A (Italia 1era división)',
    },
    {
        id: 136,
        name: 'Serie B',
    },
    {
        id: 137,
        name: 'Coppa Italia',
    },
    {
        id: 138,
        name: 'Serie C - Girone A',
    },
    {
        id: 139,
        name: 'Serie A Women',
    },
    {
        id: 140,
        name: 'La Liga EA Sports',
        slug: 'la-liga',
    },
    {
        id: 141,
        name: 'La Liga Hypermotion',
        slug: 'la-liga-segunda-division',
    },
    {
        id: 142,
        name: 'Primera División Femenina',
    },
    {
        id: 143,
        name: 'Copa del Rey',
        slug: 'copa-del-rey',
    },
    {
        id: 144,
        name: 'Jupiler Pro League',
    },
    {
        id: 145,
        name: 'Challenger Pro League',
    },
    {
        id: 146,
        name: 'Super League Women',
    },
    {
        id: 147,
        name: 'Cup',
    },
    {
        id: 148,
        name: 'Second Amateur Division - ACFF',
    },
    {
        id: 149,
        name: 'Second Amateur Division - VFV A',
    },
    {
        id: 150,
        name: 'Second Amateur Division - VFV B',
    },
    {
        id: 151,
        name: 'Third Amateur Division - VFV A',
    },
    {
        id: 152,
        name: 'Third Amateur Division - VFV B',
    },
    {
        id: 153,
        name: 'Provincial - Antwerpen',
    },
    {
        id: 154,
        name: 'Provincial - Brabant VFV',
    },
    {
        id: 155,
        name: 'Provincial - Hainaut',
    },
    {
        id: 156,
        name: 'Provincial - Liege',
    },
    {
        id: 157,
        name: 'Provincial - Limburg',
    },
    {
        id: 158,
        name: 'Provincial - Luxembourg',
    },
    {
        id: 159,
        name: 'Provincial - Namur',
    },
    {
        id: 160,
        name: 'Provincial - Oost-Vlaanderen',
    },
    {
        id: 161,
        name: 'Provincial - West-Vlaanderen',
    },
    {
        id: 162,
        name: 'Primera División',
    },
    {
        id: 163,
        name: 'Liga de Ascenso',
    },
    {
        id: 164,
        name: 'Úrvalsdeild',
    },
    {
        id: 165,
        name: '1. Deild',
    },
    {
        id: 166,
        name: '2. Deild',
    },
    {
        id: 167,
        name: 'Cup',
    },
    {
        id: 168,
        name: 'League Cup',
    },
    {
        id: 169,
        name: 'Super League',
    },
    {
        id: 170,
        name: 'League One',
    },
    {
        id: 171,
        name: 'FA Cup',
    },
    {
        id: 172,
        name: 'First League',
    },
    {
        id: 173,
        name: 'Second League',
    },
    {
        id: 174,
        name: 'Cup',
    },
    {
        id: 175,
        name: 'Third League - Northeast',
    },
    {
        id: 176,
        name: 'Third League - Northwest',
    },
    {
        id: 177,
        name: 'Third League - Southeast',
    },
    {
        id: 178,
        name: 'Third League - Southwest',
    },
    {
        id: 179,
        name: 'Premiership',
    },
    {
        id: 180,
        name: 'Championship',
    },
    {
        id: 181,
        name: 'FA Cup',
    },
    {
        id: 182,
        name: 'Challenge Cup',
    },
    {
        id: 183,
        name: 'League One',
    },
    {
        id: 184,
        name: 'League Two',
    },
    {
        id: 185,
        name: 'League Cup',
    },
    {
        id: 186,
        name: 'Ligue 1',
    },
    {
        id: 187,
        name: 'Ligue 2',
    },
    {
        id: 188,
        name: 'A-League',
    },
    {
        id: 189,
        name: 'Capital Territory NPL',
    },
    {
        id: 190,
        name: 'W-League',
    },
    {
        id: 191,
        name: 'Brisbane Premier League',
    },
    {
        id: 192,
        name: 'New South Wales NPL',
    },
    {
        id: 193,
        name: 'Northern Territory Premier League',
    },
    {
        id: 194,
        name: 'South Australia NPL',
    },
    {
        id: 195,
        name: 'Victoria NPL',
    },
    {
        id: 196,
        name: 'Western Australia NPL',
    },
    {
        id: 197,
        name: 'Super League 1',
    },
    {
        id: 198,
        name: 'Football League',
    },
    {
        id: 199,
        name: 'Cup',
    },
    {
        id: 200,
        name: 'Botola Pro',
    },
    {
        id: 201,
        name: 'Botola 2',
    },
    {
        id: 202,
        name: 'Ligue 1',
    },
    {
        id: 203,
        name: 'Süper Lig',
    },
    {
        id: 204,
        name: '1. Lig',
    },
    {
        id: 205,
        name: '2. Lig',
    },
    {
        id: 206,
        name: 'Cup',
    },
    {
        id: 207,
        name: 'Super League',
    },
    {
        id: 208,
        name: 'Challenge League',
    },
    {
        id: 209,
        name: 'Schweizer Pokal',
    },
    {
        id: 210,
        name: 'HNL',
    },
    {
        id: 211,
        name: 'First NL',
    },
    {
        id: 212,
        name: 'Cup',
    },
    {
        id: 213,
        name: 'Third NL - Istok',
    },
    {
        id: 214,
        name: 'Third NL - Jug',
    },
    {
        id: 215,
        name: 'Third NL - Sjever',
    },
    {
        id: 216,
        name: 'Third NL - Sredite',
    },
    {
        id: 217,
        name: 'Third NL - Zapad',
    },
    {
        id: 218,
        name: 'Bundesliga',
    },
    {
        id: 219,
        name: '2. Liga',
    },
    {
        id: 220,
        name: 'Cup',
    },
    {
        id: 221,
        name: 'Regionalliga - Ost',
    },
    {
        id: 222,
        name: 'Regionalliga - Mitte',
    },
    {
        id: 223,
        name: 'Regionalliga - West',
    },
    {
        id: 224,
        name: 'Landesliga - Burgenland',
    },
    {
        id: 225,
        name: 'Landesliga - Karnten',
    },
    {
        id: 226,
        name: 'Landesliga - Niederosterreich',
    },
    {
        id: 227,
        name: 'Landesliga - Oberosterreich',
    },
    {
        id: 228,
        name: 'Landesliga - Salzburg',
    },
    {
        id: 229,
        name: 'Landesliga - Steiermark',
    },
    {
        id: 230,
        name: 'Landesliga - Tirol',
    },
    {
        id: 231,
        name: 'Landesliga - Vorarlbergliga',
    },
    {
        id: 232,
        name: 'Landesliga - Wien',
    },
    {
        id: 233,
        name: 'Premier League',
    },
    {
        id: 234,
        name: 'Liga Nacional',
    },
    {
        id: 235,
        name: 'Premier League',
    },
    {
        id: 236,
        name: 'First League',
    },
    {
        id: 237,
        name: 'Cup',
    },
    {
        id: 238,
        name: 'Youth Championship',
    },
    {
        id: 239,
        name: 'Primera A',
    },
    {
        id: 240,
        name: 'Primera B',
    },
    {
        id: 241,
        name: 'Copa Colombia',
    },
    {
        id: 242,
        name: 'Liga Pro',
    },
    {
        id: 243,
        name: 'Liga Pro Serie B',
    },
    {
        id: 244,
        name: 'Veikkausliiga',
    },
    {
        id: 245,
        name: 'Ykkönen',
    },
    {
        id: 246,
        name: 'Suomen Cup',
    },
    {
        id: 247,
        name: 'Kakkonen - Lohko A',
    },
    {
        id: 248,
        name: 'Kakkonen - Lohko B',
    },
    {
        id: 249,
        name: 'Kakkonen - Lohko C',
    },
    {
        id: 250,
        name: 'Division Profesional - Apertura',
    },
    {
        id: 251,
        name: 'Division Intermedia',
    },
    {
        id: 252,
        name: 'Division Profesional - Clausura',
    },
    {
        id: 253,
        name: 'Major League Soccer',
    },
    {
        id: 254,
        name: 'NWSL Women',
    },
    {
        id: 255,
        name: 'USL Championship',
    },
    {
        id: 256,
        name: 'USL League Two',
    },
    {
        id: 257,
        name: 'US Open Cup',
    },
    {
        id: 258,
        name: 'Canadian Soccer League',
    },
    {
        id: 259,
        name: 'Canadian Championship',
    },
    {
        id: 260,
        name: 'Pacific Coast Soccer League',
    },
    {
        id: 261,
        name: 'National Division',
    },
    {
        id: 262,
        name: 'Liga MX',
    },
    {
        id: 263,
        name: 'Liga de Expansión MX',
    },
    {
        id: 264,
        name: 'Copa MX',
    },
    {
        id: 265,
        name: 'Primera División',
    },
    {
        id: 266,
        name: 'Primera B',
    },
    {
        id: 267,
        name: 'Copa Chile',
    },
    {
        id: 268,
        name: 'Primera División - Apertura',
    },
    {
        id: 269,
        name: 'Segunda División',
    },
    {
        id: 270,
        name: 'Primera División - Clausura',
    },
    {
        id: 271,
        name: 'NB I',
    },
    {
        id: 272,
        name: 'NB II',
    },
    {
        id: 273,
        name: 'Magyar Kupa',
    },
    {
        id: 274,
        name: 'Liga 1',
    },
    {
        id: 275,
        name: 'Liga 2',
    },
    {
        id: 276,
        name: 'FKF Premier League',
    },
    {
        id: 277,
        name: 'Super League',
    },
    {
        id: 278,
        name: 'Super League',
    },
    {
        id: 279,
        name: 'Premier League',
    },
    {
        id: 280,
        name: 'Premiership',
    },
    {
        id: 281,
        name: 'Primera División',
    },
    {
        id: 282,
        name: 'Segunda División',
    },
    {
        id: 283,
        name: 'Liga I',
    },
    {
        id: 284,
        name: 'Liga II',
    },
    {
        id: 285,
        name: 'Cupa României',
    },
    {
        id: 286,
        name: 'Super Liga',
    },
    {
        id: 287,
        name: 'Prva Liga',
    },
    {
        id: 288,
        name: 'Premier Soccer League',
    },
    {
        id: 289,
        name: '1st Division',
    },
    {
        id: 290,
        name: 'Persian Gulf Pro League',
    },
    {
        id: 291,
        name: 'Azadegan League',
    },
    {
        id: 292,
        name: 'K League 1',
    },
    {
        id: 293,
        name: 'K League 2',
    },
    {
        id: 294,
        name: 'FA Cup',
    },
    {
        id: 295,
        name: 'K3 League',
    },
    {
        id: 296,
        name: 'Thai League 1',
    },
    {
        id: 297,
        name: 'Thai League 2',
    },
    {
        id: 298,
        name: 'FA Cup',
    },
    {
        id: 299,
        name: 'Primera División',
    },
    {
        id: 300,
        name: 'Segunda División',
    },
    {
        id: 301,
        name: 'Pro League',
    },
    {
        id: 302,
        name: 'League Cup',
    },
    {
        id: 303,
        name: 'Division 1',
    },
    {
        id: 304,
        name: 'Liga Panameña de Fútbol',
    },
    {
        id: 305,
        name: 'Stars League',
    },
    {
        id: 306,
        name: 'Second Division',
    },
    {
        id: 307,
        name: 'Pro League',
    },
    {
        id: 308,
        name: 'Division 1',
    },
    {
        id: 309,
        name: 'Division 2',
    },
    {
        id: 310,
        name: 'Superliga',
    },
    {
        id: 311,
        name: '1st Division',
    },
    {
        id: 312,
        name: '1a Divisió',
    },
    {
        id: 313,
        name: '2a Divisió',
    },
    {
        id: 314,
        name: 'Cup',
    },
    {
        id: 315,
        name: 'Premijer Liga',
    },
    {
        id: 316,
        name: '1st League - FBiH',
    },
    {
        id: 317,
        name: '1st League - RS',
    },
    {
        id: 318,
        name: '1. Division',
    },
    {
        id: 319,
        name: '2. Division',
    },
    {
        id: 320,
        name: '3. Division',
    },
    {
        id: 321,
        name: 'Cup',
    },
    {
        id: 322,
        name: 'Premier League',
    },
    {
        id: 323,
        name: 'Indian Super League',
    },
    {
        id: 324,
        name: 'I-League',
    },
    {
        id: 325,
        name: 'Santosh Trophy',
    },
    {
        id: 326,
        name: 'Erovnuli Liga 2',
    },
    {
        id: 327,
        name: 'Erovnuli Liga',
    },
    {
        id: 328,
        name: 'Esiliiga A',
    },
    {
        id: 329,
        name: 'Meistriliiga',
    },
    {
        id: 330,
        name: 'Premier League',
    },
    {
        id: 331,
        name: 'Division 1',
    },
    {
        id: 332,
        name: 'Super Liga',
    },
    {
        id: 333,
        name: 'Premier League',
    },
    {
        id: 334,
        name: 'Persha Liga',
    },
    {
        id: 335,
        name: 'Cup',
    },
    {
        id: 336,
        name: 'Druha Liga - Group A',
    },
    {
        id: 337,
        name: 'Druha Liga - Group B',
    },
    {
        id: 338,
        name: 'Primera Division',
    },
    {
        id: 339,
        name: 'Liga Nacional',
    },
    {
        id: 340,
        name: 'V.League 1',
    },
    {
        id: 341,
        name: 'Cup',
    },
    {
        id: 342,
        name: 'Premier League',
    },
    {
        id: 343,
        name: 'First League',
    },
    {
        id: 344,
        name: 'Primera División',
    },
    {
        id: 345,
        name: 'Czech Liga',
    },
    {
        id: 346,
        name: 'FNL',
    },
    {
        id: 347,
        name: 'Cup',
    },
    {
        id: 348,
        name: '3. liga - CFL A',
    },
    {
        id: 349,
        name: '3. liga - MSFL',
    },
    {
        id: 350,
        name: '4. liga - Divizie A',
    },
    {
        id: 351,
        name: '4. liga - Divizie B',
    },
    {
        id: 352,
        name: '4. liga - Divizie C',
    },
    {
        id: 353,
        name: '4. liga - Divizie D',
    },
    {
        id: 354,
        name: '4. liga - Divizie E',
    },
    {
        id: 355,
        name: 'First League',
    },
    {
        id: 356,
        name: 'Second League',
    },
    {
        id: 357,
        name: 'Premier Division',
    },
    {
        id: 358,
        name: 'First Division',
    },
    {
        id: 359,
        name: 'FAI Cup',
    },
    {
        id: 360,
        name: 'League Cup',
    },
    {
        id: 361,
        name: '1 Lyga',
    },
    {
        id: 362,
        name: 'A Lyga',
    },
    {
        id: 363,
        name: 'Premier League',
    },
    {
        id: 364,
        name: '1. Liga',
    },
    {
        id: 365,
        name: 'Virsliga',
    },
    {
        id: 366,
        name: '1. Deild',
    },
    {
        id: 367,
        name: 'Meistaradeildin',
    },
    {
        id: 368,
        name: 'Premier League',
    },
    {
        id: 369,
        name: 'Super League',
    },
    {
        id: 370,
        name: 'Primera Division',
    },
    {
        id: 371,
        name: 'First League',
    },
    {
        id: 372,
        name: 'Second League',
    },
    {
        id: 373,
        name: '1. SNL',
    },
    {
        id: 374,
        name: '2. SNL',
    },
    {
        id: 375,
        name: 'Cup',
    },
    {
        id: 376,
        name: 'National Football League',
    },
    {
        id: 377,
        name: 'Division dHonneur',
    },
    {
        id: 378,
        name: 'Ligue 1',
    },
    {
        id: 379,
        name: 'Ligue Haïtienne',
    },
    {
        id: 380,
        name: 'Premier League',
    },
    {
        id: 381,
        name: 'HKFA 1st Division',
    },
    {
        id: 382,
        name: 'Liga Leumit',
    },
    {
        id: 383,
        name: 'Ligat Haal',
    },
    {
        id: 384,
        name: 'State Cup',
    },
    {
        id: 385,
        name: 'Toto Cup Ligat Al',
    },
    {
        id: 386,
        name: 'Ligue 1',
    },
    {
        id: 387,
        name: 'League',
    },
    {
        id: 388,
        name: '1. Division',
    },
    {
        id: 389,
        name: 'Premier League',
    },
    {
        id: 390,
        name: 'Premier League',
    },
    {
        id: 391,
        name: 'Super League',
    },
    {
        id: 392,
        name: 'Challenge League',
    },
    {
        id: 393,
        name: 'Premier League',
    },
    {
        id: 394,
        name: 'Super Liga',
    },
    {
        id: 395,
        name: 'Liga 1',
    },
    {
        id: 396,
        name: 'Primera Division',
    },
    {
        id: 397,
        name: 'Girabola',
    },
    {
        id: 398,
        name: 'Premier League',
    },
    {
        id: 399,
        name: 'NPFL',
    },
    {
        id: 400,
        name: 'Super League',
    },
    {
        id: 401,
        name: 'Premier Soccer League',
    },
    {
        id: 402,
        name: 'Sudani Premier League',
    },
    {
        id: 403,
        name: 'Ligue 1',
    },
    {
        id: 404,
        name: 'Campionato',
    },
    {
        id: 405,
        name: 'National Soccer League',
    },
    {
        id: 406,
        name: 'Professional League',
    },
    {
        id: 407,
        name: 'Championship',
    },
    {
        id: 408,
        name: 'Premiership',
    },
    {
        id: 409,
        name: 'Premier League',
    },
    {
        id: 410,
        name: 'C-League',
    },
    {
        id: 411,
        name: 'Elite One',
    },
    {
        id: 412,
        name: 'Premier League',
    },
    {
        id: 413,
        name: 'Super League',
    },
    {
        id: 414,
        name: 'Premier League',
    },
    {
        id: 415,
        name: 'Championnat National',
    },
    {
        id: 416,
        name: 'Premier League',
    },
    {
        id: 417,
        name: 'Premier League',
    },
    {
        id: 418,
        name: 'Birinci Dasta',
    },
    {
        id: 419,
        name: 'Premyer Liqa',
    },
    {
        id: 420,
        name: 'Cup',
    },
    {
        id: 421,
        name: 'Division di Honor',
    },
    {
        id: 422,
        name: 'Premier League',
    },
    {
        id: 423,
        name: 'Ligue 1',
    },
    {
        id: 424,
        name: 'Ligue 1',
    },
    {
        id: 425,
        name: 'Premier League',
    },
    {
        id: 426,
        name: 'Serie D - Girone A',
    },
    {
        id: 427,
        name: 'Serie D - Girone B',
    },
    {
        id: 428,
        name: 'Serie D - Girone C',
    },
    {
        id: 429,
        name: 'Serie D - Girone D',
    },
    {
        id: 430,
        name: 'Serie D - Girone E',
    },
    {
        id: 431,
        name: 'Serie D - Girone F',
    },
    {
        id: 432,
        name: 'Serie D - Girone G',
    },
    {
        id: 433,
        name: 'Serie D - Girone H',
    },
    {
        id: 434,
        name: 'Serie D - Girone I',
    },
    {
        id: 435,
        name: 'Primera División RFEF - Group 1',
    },
    {
        id: 436,
        name: 'Primera División RFEF - Group 2',
    },
    {
        id: 437,
        name: 'Primera División RFEF - Group 3',
    },
    {
        id: 438,
        name: 'Primera División RFEF - Group 4',
    },
    {
        id: 439,
        name: 'Tercera División RFEF - Group 1',
    },
    {
        id: 440,
        name: 'Tercera División RFEF - Group 2',
    },
    {
        id: 441,
        name: 'Tercera División RFEF - Group 3',
    },
    {
        id: 442,
        name: 'Tercera División RFEF - Group 4',
    },
    {
        id: 443,
        name: 'Tercera División RFEF - Group 5',
    },
    {
        id: 444,
        name: 'Tercera División RFEF - Group 6',
    },
    {
        id: 445,
        name: 'Tercera División RFEF - Group 7',
    },
    {
        id: 446,
        name: 'Tercera División RFEF - Group 8',
    },
    {
        id: 447,
        name: 'Tercera División RFEF - Group 9',
    },
    {
        id: 448,
        name: 'Tercera División RFEF - Group 10',
    },
    {
        id: 449,
        name: 'Tercera División RFEF - Group 11',
    },
    {
        id: 450,
        name: 'Tercera División RFEF - Group 12',
    },
    {
        id: 451,
        name: 'Tercera División RFEF - Group 13',
    },
    {
        id: 452,
        name: 'Tercera División RFEF - Group 14',
    },
    {
        id: 453,
        name: 'Tercera División RFEF - Group 15',
    },
    {
        id: 454,
        name: 'Tercera División RFEF - Group 16',
    },
    {
        id: 455,
        name: 'Tercera División RFEF - Group 17',
    },
    {
        id: 456,
        name: 'Tercera División RFEF - Group 18',
    },
    {
        id: 457,
        name: 'Campeonato de Portugal Prio - Group A',
    },
    {
        id: 458,
        name: 'Campeonato de Portugal Prio - Group B',
    },
    {
        id: 459,
        name: 'Campeonato de Portugal Prio - Group C',
    },
    {
        id: 460,
        name: 'Campeonato de Portugal Prio - Group D',
    },
    {
        id: 461,
        name: 'National 3 - Group A',
    },
    {
        id: 462,
        name: 'National 3 - Group B',
    },
    {
        id: 463,
        name: 'National 3 - Group C',
    },
    {
        id: 464,
        name: 'National 3 - Group D',
    },
    {
        id: 465,
        name: 'National 3 - Group E',
    },
    {
        id: 466,
        name: 'National 3 - Group F',
    },
    {
        id: 467,
        name: 'National 3 - Group H',
    },
    {
        id: 468,
        name: 'National 3 - Group I',
    },
    {
        id: 469,
        name: 'National 3 - Group J',
    },
    {
        id: 470,
        name: 'National 3 - Group K',
    },
    {
        id: 471,
        name: 'National 3 - Group L',
    },
    {
        id: 472,
        name: 'National 3 - Group M',
    },
    {
        id: 473,
        name: '2. Division - Group 1',
    },
    {
        id: 474,
        name: '2. Division - Group 2',
    },
    {
        id: 475,
        name: 'Paulista - A1',
    },
    {
        id: 476,
        name: 'Paulista - A2',
    },
    {
        id: 477,
        name: 'Gaúcho - 1',
    },
    {
        id: 478,
        name: 'Gaúcho - 2',
    },
    {
        id: 479,
        name: 'Canadian Premier League',
    },
    {
        id: 480,
        name: 'Olympics Men',
    },
    {
        id: 481,
        name: 'Northern NSW NPL',
    },
    {
        id: 482,
        name: 'Queensland NPL',
    },
    {
        id: 483,
        name: 'Copa de la Superliga',
    },
    {
        id: 484,
        name: 'Frauenliga',
    },
    {
        id: 485,
        name: 'Federation Cup',
    },
    {
        id: 486,
        name: 'Coppa',
    },
    {
        id: 487,
        name: 'First Amateur Division',
    },
    {
        id: 488,
        name: 'U19 Bundesliga',
    },
    {
        id: 489,
        name: 'USL League One',
    },
    {
        id: 490,
        name: 'World Cup - U20',
    },
    {
        id: 491,
        name: 'Løgmanssteypid',
    },
    {
        id: 492,
        name: 'Tweede Divisie',
    },
    {
        id: 493,
        name: 'UEFA U19 Championship',
    },
    {
        id: 494,
        name: 'Super League 2',
    },
    {
        id: 495,
        name: 'Hazfi Cup',
    },
    {
        id: 496,
        name: 'Liga Alef',
    },
    {
        id: 497,
        name: 'Japan Football League',
    },
    {
        id: 498,
        name: 'Cup',
    },
    {
        id: 499,
        name: 'Malaysia Cup',
    },
    {
        id: 500,
        name: 'FA Cup',
    },
    {
        id: 501,
        name: 'Copa Paraguay',
    },
    {
        id: 502,
        name: 'Copa Bicentenario',
    },
    {
        id: 503,
        name: 'Copa Perú',
    },
    {
        id: 504,
        name: 'Kings Cup',
    },
    {
        id: 505,
        name: 'League Cup',
    },
    {
        id: 506,
        name: '2. liga',
    },
    {
        id: 507,
        name: 'Cup',
    },
    {
        id: 508,
        name: 'League Cup',
    },
    {
        id: 509,
        name: '8 Cup',
    },
    {
        id: 510,
        name: '1. Liga Promotion',
    },
    {
        id: 511,
        name: 'Cup',
    },
    {
        id: 512,
        name: '2nd Division - Group A',
    },
    {
        id: 513,
        name: '2nd Division - Group B',
    },
    {
        id: 514,
        name: 'Coupe Nationale',
    },
    {
        id: 515,
        name: 'U21 League 1',
    },
    {
        id: 516,
        name: 'Super Cup',
    },
    {
        id: 517,
        name: 'Trofeo de Campeones de la Superliga',
        type: 'Cup',
        logo: 'https://media.api-sports.io/football/leagues/517.png',
    },
    {
        id: 518,
        name: 'Reserve Pro League',
    },
    {
        id: 519,
        name: 'Super Cup',
    },
    {
        id: 520,
        name: 'Acreano',
    },
    {
        id: 521,
        name: 'Amapaense',
    },
    {
        id: 522,
        name: 'Amazonense',
    },
    {
        id: 523,
        name: 'NISA',
    },
    {
        id: 524,
        name: 'Olympics Women',
    },
    {
        id: 525,
        name: 'UEFA Champions League Women',
    },
    {
        id: 526,
        name: 'Trophée des Champions',
    },
    {
        id: 527,
        name: 'Super Cup',
    },
    {
        id: 528,
        name: 'Community Shield',
    },
    {
        id: 529,
        name: 'Super Cup',
    },
    {
        id: 530,
        name: 'Super Cup',
    },
    {
        id: 531,
        name: 'UEFA Super Cup',
    },
    {
        id: 532,
        name: 'AFC U23 Championship',
    },
    {
        id: 533,
        name: 'CAF Super Cup',
    },
    {
        id: 534,
        name: 'CONCACAF Caribbean Club Shield',
    },
    {
        id: 535,
        name: 'CECAFA Senior Challenge Cup',
    },
    {
        id: 536,
        name: 'CONCACAF Nations League',
    },
    {
        id: 537,
        name: 'CONCACAF U20',
    },
    {
        id: 538,
        name: 'Africa Cup of Nations U20',
    },
    {
        id: 539,
        name: 'Super Cup',
    },
    {
        id: 540,
        name: 'CONMEBOL Libertadores U20',
    },
    {
        id: 541,
        name: 'CONMEBOL Recopa',
    },
    {
        id: 542,
        name: 'Iraqi League',
    },
    {
        id: 543,
        name: 'Super Cup',
    },
    {
        id: 544,
        name: 'FA Cup',
    },
    {
        id: 545,
        name: 'AIFF Super Cup',
    },
    {
        id: 546,
        name: 'FAI Presidents Cup',
    },
    {
        id: 547,
        name: 'Super Cup',
    },
    {
        id: 548,
        name: 'Super Cup',
    },
    {
        id: 549,
        name: 'Damallsvenskan',
    },
    {
        id: 550,
        name: 'Super Cup',
    },
    {
        id: 551,
        name: 'Super Cup',
    },
    {
        id: 552,
        name: '3. Lig - Group 1',
    },
    {
        id: 553,
        name: '3. Lig - Group 2',
    },
    {
        id: 554,
        name: '3. Lig - Group 3',
    },
    {
        id: 555,
        name: 'Supercupa',
    },
    {
        id: 556,
        name: 'Super Cup',
    },
    {
        id: 557,
        name: 'Super Cup',
    },
    {
        id: 558,
        name: 'Supercopa',
    },
    {
        id: 559,
        name: 'League Cup',
    },
    {
        id: 560,
        name: 'Presidents Cup',
    },
    {
        id: 561,
        name: 'Premier Intermediate League',
    },
    {
        id: 562,
        name: 'Reserve League',
    },
    {
        id: 563,
        name: 'Ettan - Norra',
    },
    {
        id: 564,
        name: 'Ettan - Södra',
    },
    {
        id: 565,
        name: 'Liga Primera U20',
    },
    {
        id: 566,
        name: 'Ligue A',
    },
    {
        id: 567,
        name: 'Ligi kuu Bara',
    },
    {
        id: 568,
        name: 'Eerste Divisie',
    },
    {
        id: 569,
        name: 'Premier League',
    },
    {
        id: 570,
        name: 'Premier League',
    },
    {
        id: 571,
        name: 'Vysshaya Liga',
    },
    {
        id: 572,
        name: 'Srpska Liga - Belgrade',
    },
    {
        id: 573,
        name: 'Srpska Liga - Vojvodina',
    },
    {
        id: 574,
        name: 'Srpska Liga - East',
    },
    {
        id: 575,
        name: 'Srpska Liga - West',
    },
    {
        id: 576,
        name: 'Gamma Ethniki - Group 1',
    },
    {
        id: 577,
        name: 'Gamma Ethniki - Group 2',
    },
    {
        id: 578,
        name: 'Gamma Ethniki - Group 3',
    },
    {
        id: 579,
        name: 'Gamma Ethniki - Group 4',
    },
    {
        id: 580,
        name: 'Gamma Ethniki - Group 5',
    },
    {
        id: 581,
        name: 'Gamma Ethniki - Group 6',
    },
    {
        id: 582,
        name: 'Gamma Ethniki - Group 7',
    },
    {
        id: 583,
        name: 'Gamma Ethniki - Group 8',
    },
    {
        id: 584,
        name: 'Premier League',
    },
    {
        id: 585,
        name: 'Premier League',
    },
    {
        id: 586,
        name: 'West Bank Premier League',
    },
    {
        id: 587,
        name: 'World Cup - U17',
    },
    {
        id: 588,
        name: 'National League',
    },
    {
        id: 589,
        name: 'Taiwan Football Premier League',
    },
    {
        id: 590,
        name: 'A Division',
    },
    {
        id: 591,
        name: 'Pro League',
    },
    {
        id: 592,
        name: 'Division 2 - Norra Götaland',
    },
    {
        id: 593,
        name: 'Division 2 - Norra Svealand',
    },
    {
        id: 594,
        name: 'Division 2 - Norrland',
    },
    {
        id: 595,
        name: 'Division 2 - Södra Svealand',
    },
    {
        id: 596,
        name: 'Division 2 - Västra Götaland',
    },
    {
        id: 597,
        name: 'Division 2 - Östra Götaland',
    },
    {
        id: 598,
        name: 'Première Division',
    },
    {
        id: 599,
        name: '1. Liga Classic - Group 1',
    },
    {
        id: 600,
        name: '1. Liga Classic - Group 2',
    },
    {
        id: 601,
        name: '1. Liga Classic - Group 3',
    },
    {
        id: 602,
        name: 'Baiano - 1',
    },
    {
        id: 603,
        name: 'Paraibano',
    },
    {
        id: 604,
        name: 'Catarinense - 1',
    },
    {
        id: 605,
        name: 'Paulista - A3',
    },
    {
        id: 606,
        name: 'Paranaense - 1',
    },
    {
        id: 607,
        name: 'Roraimense',
    },
    {
        id: 608,
        name: 'Maranhense',
    },
    {
        id: 609,
        name: 'Cearense - 1',
    },
    {
        id: 610,
        name: 'Brasiliense',
    },
    {
        id: 611,
        name: 'Capixaba',
    },
    {
        id: 612,
        name: 'Copa do Nordeste',
    },
    {
        id: 613,
        name: 'Baiano - 2',
    },
    {
        id: 614,
        name: 'Paranaense - 2',
    },
    {
        id: 615,
        name: 'Rondoniense',
    },
    {
        id: 616,
        name: 'Potiguar',
    },
    {
        id: 617,
        name: 'Copa do Brasil U20',
    },
    {
        id: 618,
        name: 'São Paulo Youth Cup',
    },
    {
        id: 619,
        name: 'Mineiro - 2',
    },
    {
        id: 620,
        name: 'Cearense - 2',
    },
    {
        id: 621,
        name: 'Piauiense',
    },
    {
        id: 622,
        name: 'Pernambucano - 1',
    },
    {
        id: 623,
        name: 'Sul-Matogrossense',
    },
    {
        id: 624,
        name: 'Carioca - 1',
    },
    {
        id: 625,
        name: 'Carioca - 2',
    },
    {
        id: 626,
        name: 'Sergipano',
    },
    {
        id: 627,
        name: 'Paraense',
    },
    {
        id: 628,
        name: 'Goiano - 1',
    },
    {
        id: 629,
        name: 'Mineiro - 1',
    },
    {
        id: 630,
        name: 'Matogrossense',
    },
    {
        id: 631,
        name: 'Tocantinense',
    },
    {
        id: 632,
        name: 'Supercopa do Brasil',
    },
    {
        id: 633,
        name: 'NB III - Keleti',
    },
    {
        id: 634,
        name: 'NB III - Nyugati',
    },
    {
        id: 635,
        name: 'NB III - Közép',
    },
    {
        id: 636,
        name: 'Ýokary Liga',
    },
    {
        id: 637,
        name: 'V.League 2',
    },
    {
        id: 638,
        name: 'Kvindeliga',
    },
    {
        id: 639,
        name: 'Super Cup',
    },
    {
        id: 640,
        name: 'Kansallinen Liiga',
    },
    {
        id: 641,
        name: 'NWSL Women - Challenge Cup',
    },
    {
        id: 642,
        name: 'Curaçao Sekshon Pagá',
    },
    {
        id: 643,
        name: '3. liga - Bratislava',
    },
    {
        id: 644,
        name: '3. liga - West',
    },
    {
        id: 645,
        name: '3. liga - East',
    },
    {
        id: 646,
        name: '3. liga - Center',
    },
    {
        id: 647,
        name: 'Lao League',
    },
    {
        id: 648,
        name: 'Tasmania NPL',
    },
    {
        id: 649,
        name: 'Supreme Division Women',
    },
    {
        id: 650,
        name: 'Second League - Group 3',
    },
    {
        id: 651,
        name: 'Second League - Group 1',
    },
    {
        id: 652,
        name: 'Second League - Group 2',
    },
    {
        id: 653,
        name: 'Second League - Group 4',
    },
    {
        id: 654,
        name: 'Super Cup',
    },
    {
        id: 655,
        name: 'Copa Constitució',
    },
    {
        id: 656,
        name: 'Super Cup',
    },
    {
        id: 657,
        name: 'Cup',
    },
    {
        id: 658,
        name: 'Cup',
    },
    {
        id: 659,
        name: 'Super Cup',
    },
    {
        id: 660,
        name: 'WK-League',
    },
    {
        id: 661,
        name: 'Cup',
    },
    {
        id: 662,
        name: 'Copa por México',
    },
    {
        id: 663,
        name: 'Super Cup',
    },
    {
        id: 664,
        name: 'Superliga',
    },
    {
        id: 665,
        name: 'Cup',
    },
    {
        id: 666,
        name: 'Friendlies Women',
    },
    {
        id: 667,
        name: 'Amistosos de clubes',
    },
    {
        id: 668,
        name: '1. Liga U19',
    },
    {
        id: 669,
        name: '1. Liga Women',
    },
    {
        id: 670,
        name: 'Community Shield Women',
    },
    {
        id: 671,
        name: 'Úrvalsdeild Women',
    },
    {
        id: 672,
        name: 'David Kipiani Cup',
    },
    {
        id: 673,
        name: 'Liga MX Femenil',
    },
    {
        id: 674,
        name: 'Cupa',
    },
    {
        id: 675,
        name: 'U21 Divisie 1',
    },
    {
        id: 676,
        name: 'Central Youth League',
    },
    {
        id: 677,
        name: 'QSL Cup',
    },
    {
        id: 678,
        name: 'Super Cup',
    },
    {
        id: 679,
        name: 'U21 League',
    },
    {
        id: 680,
        name: 'Cup',
    },
    {
        id: 681,
        name: 'Campeonato de Portugal Prio - Group E',
    },
    {
        id: 682,
        name: 'Campeonato de Portugal Prio - Group F',
    },
    {
        id: 683,
        name: 'Campeonato de Portugal Prio - Group G',
    },
    {
        id: 684,
        name: 'Campeonato de Portugal Prio - Group H',
    },
    {
        id: 685,
        name: '3. liga - CFL B',
    },
    {
        id: 686,
        name: '4. liga - Divizie F',
    },
    {
        id: 687,
        name: 'Regionalliga - Tirol',
    },
    {
        id: 688,
        name: 'Regionalliga - Salzburg',
    },
    {
        id: 689,
        name: 'Third Amateur Division - ACFF A',
    },
    {
        id: 690,
        name: 'Third Amateur Division - ACFF B',
    },
    {
        id: 691,
        name: 'Provincial - Brabant ACFF',
    },
    {
        id: 692,
        name: 'Primera División RFEF - Group 5',
    },
    {
        id: 693,
        name: 'Gamma Ethniki - Group 9',
    },
    {
        id: 694,
        name: 'Gamma Ethniki - Group 10',
    },
    {
        id: 695,
        name: 'U18 Premier League - North',
    },
    {
        id: 696,
        name: 'U18 Premier League - South',
    },
    {
        id: 697,
        name: 'WSL Cup',
    },
    {
        id: 698,
        name: 'FA Womens Cup',
    },
    {
        id: 699,
        name: 'Womens Championship',
    },
    {
        id: 700,
        name: 'Kakkosen Cup',
    },
    {
        id: 701,
        name: 'Liga Revelação U23',
    },
    {
        id: 702,
        name: 'Premier League 2 Division One',
    },
    {
        id: 703,
        name: 'Professional Development League',
    },
    {
        id: 704,
        name: 'Coppa Italia Primavera',
    },
    {
        id: 705,
        name: 'Campionato Primavera - 1',
    },
    {
        id: 706,
        name: 'Campionato Primavera - 2',
    },
    {
        id: 707,
        name: 'Cup',
    },
    {
        id: 708,
        name: 'Super Cup',
    },
    {
        id: 709,
        name: 'Cup',
    },
    {
        id: 710,
        name: 'Nacional B',
    },
    {
        id: 711,
        name: 'Segunda División',
    },
    {
        id: 712,
        name: 'Liga Femenina',
    },
    {
        id: 713,
        name: 'Superliga',
    },
    {
        id: 714,
        name: 'Cup',
    },
    {
        id: 715,
        name: 'DFB Junioren Pokal',
    },
    {
        id: 716,
        name: 'Senior Shield',
    },
    {
        id: 717,
        name: 'I-League - 2nd Division',
    },
    {
        id: 718,
        name: 'Piala Indonesia',
    },
    {
        id: 719,
        name: 'Super Cup',
    },
    {
        id: 720,
        name: 'Emir Cup',
    },
    {
        id: 721,
        name: 'Cup',
    },
    {
        id: 722,
        name: 'Liga Premier Serie A',
    },
    {
        id: 723,
        name: 'Cup',
    },
    {
        id: 724,
        name: 'U18 Divisie 1',
    },
    {
        id: 725,
        name: 'Toppserien',
    },
    {
        id: 726,
        name: 'Sultan Cup',
    },
    {
        id: 727,
        name: 'Super Cup',
    },
    {
        id: 728,
        name: 'Liga 1 Feminin',
    },
    {
        id: 729,
        name: 'Coppa Titano',
    },
    {
        id: 730,
        name: 'Football League - Highland League',
    },
    {
        id: 731,
        name: 'Football League - Lowland League',
    },
    {
        id: 732,
        name: 'Cup',
    },
    {
        id: 733,
        name: 'I Liga - Women',
    },
    {
        id: 734,
        name: 'Diski Challenge',
    },
    {
        id: 735,
        name: 'Copa Federacion',
    },
    {
        id: 736,
        name: 'Elitettan',
    },
    {
        id: 737,
        name: 'Svenska Cupen - Women',
    },
    {
        id: 738,
        name: 'League Cup',
    },
    {
        id: 739,
        name: 'Nationalliga A Women',
    },
    {
        id: 740,
        name: 'CBF Brasileiro U20',
    },
    {
        id: 741,
        name: 'Brasileiro de Aspirantes',
    },
    {
        id: 742,
        name: 'Copa Paulista',
    },
    {
        id: 743,
        name: 'UEFA Championship - Women',
    },
    {
        id: 744,
        name: 'Oberliga - Schleswig-Holstein',
    },
    {
        id: 745,
        name: 'Oberliga - Hamburg',
    },
    {
        id: 746,
        name: 'Oberliga - Mittelrhein',
    },
    {
        id: 747,
        name: 'Oberliga - Westfalen',
    },
    {
        id: 748,
        name: 'Oberliga - Niedersachsen',
    },
    {
        id: 749,
        name: 'Oberliga - Bremen',
    },
    {
        id: 750,
        name: 'Oberliga - Hessen',
    },
    {
        id: 751,
        name: 'Oberliga - Niederrhein',
    },
    {
        id: 752,
        name: 'Oberliga - Rheinland-Pfalz / Saar',
    },
    {
        id: 753,
        name: 'Oberliga - Baden-Württemberg',
    },
    {
        id: 754,
        name: 'Oberliga - Nordost-Nord',
    },
    {
        id: 755,
        name: 'Oberliga - Nordost-Süd',
    },
    {
        id: 756,
        name: 'Cup',
    },
    {
        id: 757,
        name: 'Irish Cup',
    },
    {
        id: 758,
        name: 'Premier Division',
    },
    {
        id: 759,
        name: 'Liga Mayor',
    },
    {
        id: 760,
        name: 'LFA First Division',
    },
    {
        id: 761,
        name: 'Cup',
    },
    {
        id: 762,
        name: 'Premier League',
    },
    {
        id: 763,
        name: 'Mauritian League',
    },
    {
        id: 764,
        name: 'Premier League',
    },
    {
        id: 765,
        name: 'PFL',
    },
    {
        id: 766,
        name: 'China Cup',
    },
    {
        id: 767,
        name: 'CONCACAF League',
    },
    {
        id: 768,
        name: 'Arab Club Champions Cup',
    },
    {
        id: 769,
        name: 'Premier League Asia Trophy',
    },
    {
        id: 770,
        name: 'Pacific Games',
    },
    {
        id: 771,
        name: 'COSAFA U20 Championship',
    },
    {
        id: 772,
        name: 'Leagues Cup',
    },
    {
        id: 773,
        name: 'Sudamericano U20',
    },
    {
        id: 774,
        name: '3. Division - Girone 1',
    },
    {
        id: 775,
        name: '3. Division - Girone 2',
    },
    {
        id: 776,
        name: '3. Division - Girone 3',
    },
    {
        id: 777,
        name: '3. Division - Girone 4',
    },
    {
        id: 778,
        name: '3. Division - Girone 5',
    },
    {
        id: 779,
        name: '3. Division - Girone 6',
    },
    {
        id: 780,
        name: 'III Liga - Group 1',
    },
    {
        id: 781,
        name: 'III Liga - Group 2',
    },
    {
        id: 782,
        name: 'III Liga - Group 3',
    },
    {
        id: 783,
        name: 'III Liga - Group 4',
    },
    {
        id: 784,
        name: 'Liga III - Serie 1',
    },
    {
        id: 785,
        name: 'Liga III - Serie 2',
    },
    {
        id: 786,
        name: 'Liga III - Serie 3',
    },
    {
        id: 787,
        name: 'Liga III - Serie 4',
    },
    {
        id: 788,
        name: 'Liga III - Serie 5',
    },
    {
        id: 789,
        name: 'Liga III - Serie 6',
    },
    {
        id: 790,
        name: 'Liga III - Serie 7',
    },
    {
        id: 791,
        name: 'Liga III - Serie 8',
    },
    {
        id: 792,
        name: 'Liga III - Serie 9',
    },
    {
        id: 793,
        name: 'Liga III - Serie 10',
    },
    {
        id: 794,
        name: '3. SNL - East',
    },
    {
        id: 795,
        name: '3. SNL - West',
    },
    {
        id: 796,
        name: '2. Liga Interregional - Group 1',
    },
    {
        id: 797,
        name: '2. Liga Interregional - Group 2',
    },
    {
        id: 798,
        name: '2. Liga Interregional - Group 3',
    },
    {
        id: 799,
        name: '2. Liga Interregional - Group 4',
    },
    {
        id: 800,
        name: '2. Liga Interregional - Group 5',
    },
    {
        id: 801,
        name: '2. Liga Interregional - Group 6',
    },
    {
        id: 802,
        name: 'Cup',
    },
    {
        id: 803,
        name: 'Asian Games',
    },
    {
        id: 804,
        name: 'Caribbean Cup',
    },
    {
        id: 805,
        name: 'Copa Centroamericana',
    },
    {
        id: 806,
        name: 'OFC Nations Cup',
    },
    {
        id: 807,
        name: 'AFC Challenge Cup',
    },
    {
        id: 808,
        name: 'CONCACAF Nations League - Qualification',
    },
    {
        id: 809,
        name: 'Super Cup',
    },
    {
        id: 810,
        name: 'Super Copa',
    },
    {
        id: 811,
        name: 'Federation Cup',
    },
    {
        id: 812,
        name: 'Super Cup',
    },
    {
        id: 813,
        name: 'Elite Two',
    },
    {
        id: 814,
        name: 'Reykjavik Cup',
    },
    {
        id: 815,
        name: 'Fotbolti.net Cup A',
    },
    {
        id: 816,
        name: 'Shield Cup',
    },
    {
        id: 817,
        name: 'Super Cup Primavera',
    },
    {
        id: 818,
        name: 'Super Cup',
    },
    {
        id: 819,
        name: 'Super Cup',
    },
    {
        id: 820,
        name: 'Crown Prince Cup',
    },
    {
        id: 821,
        name: 'FA Trophy',
    },
    {
        id: 822,
        name: 'Cup',
    },
    {
        id: 823,
        name: 'Nasjonal U19 Champions League',
    },
    {
        id: 824,
        name: 'Emir Cup',
    },
    {
        id: 825,
        name: 'Qatar Cup',
    },
    {
        id: 826,
        name: 'Super Cup',
    },
    {
        id: 827,
        name: 'Crown Prince Cup',
    },
    {
        id: 828,
        name: 'Ligue 2',
    },
    {
        id: 829,
        name: 'Youth League',
    },
    {
        id: 830,
        name: 'Super Cup',
    },
    {
        id: 831,
        name: 'Super Cup',
    },
    {
        id: 832,
        name: 'Coupe de la Ligue',
    },
    {
        id: 833,
        name: 'Queensland Premier League',
    },
    {
        id: 834,
        name: 'South Australia State League 1',
    },
    {
        id: 835,
        name: 'New South Wales NPL 2',
    },
    {
        id: 836,
        name: 'Victoria NPL 2',
    },
    {
        id: 837,
        name: 'Rock Cup',
    },
    {
        id: 838,
        name: 'Super Cup',
    },
    {
        id: 839,
        name: 'Super Cup',
    },
    {
        id: 840,
        name: 'Taça Revelação U23',
    },
    {
        id: 841,
        name: 'QFA Cup',
    },
    {
        id: 842,
        name: 'Super Copa',
    },
    {
        id: 843,
        name: 'Copa Verde',
    },
    {
        id: 844,
        name: 'Ligue 1',
    },
    {
        id: 845,
        name: 'GFA League',
    },
    {
        id: 846,
        name: 'Somali Premier League',
    },
    {
        id: 847,
        name: 'Premier League',
    },
    {
        id: 848,
        name: 'UEFA Europa Conference League',
    },
    {
        id: 849,
        name: 'Baltic Cup',
    },
    {
        id: 850,
        name: 'UEFA U21 Championship - Qualification',
    },
    {
        id: 851,
        name: 'Carioca A2',
    },
    {
        id: 852,
        name: 'Super Cup',
    },
    {
        id: 853,
        name: 'Supercopa de Ecuador',
    },
    {
        id: 854,
        name: 'WE League',
    },
    {
        id: 855,
        name: 'Dhivehi Premier League',
    },
    {
        id: 856,
        name: 'CONCACAF Caribbean Club Championship',
    },
    {
        id: 857,
        name: 'Campeón de Campeones',
    },
    {
        id: 858,
        name: 'CONCACAF Gold Cup - Qualification',
    },
    {
        id: 859,
        name: 'COSAFA Cup',
    },
    {
        id: 860,
        name: 'Arab Cup',
    },
    {
        id: 861,
        name: 'U20 League',
    },
    {
        id: 862,
        name: '3. Division',
    },
    {
        id: 863,
        name: 'Cup',
    },
    {
        id: 864,
        name: 'Supercopa',
    },
    {
        id: 865,
        name: 'Liga 3',
    },
    {
        id: 866,
        name: 'MLS All-Star',
    },
    {
        id: 867,
        name: 'Copa Paulino Alcantara',
    },
    {
        id: 868,
        name: 'Premier League',
    },
    {
        id: 869,
        name: 'CECAFA Club Cup',
    },
    {
        id: 870,
        name: 'Premier League',
    },
    {
        id: 871,
        name: 'Premier League Cup',
    },
    {
        id: 872,
        name: 'Liga Premier Serie B',
    },
    {
        id: 873,
        name: 'Thai Champions Cup',
    },
    {
        id: 874,
        name: 'Australia Cup',
    },
    {
        id: 875,
        name: 'Segunda División RFEF - Group 1',
    },
    {
        id: 876,
        name: 'Segunda División RFEF - Group 2',
    },
    {
        id: 877,
        name: 'Segunda División RFEF - Group 3',
    },
    {
        id: 878,
        name: 'Segunda División RFEF - Group 4',
    },
    {
        id: 879,
        name: 'Segunda División RFEF - Group 5',
    },
    {
        id: 880,
        name: 'World Cup - Women - Qualification Europe',
    },
    {
        id: 881,
        name: 'Olympics Men - Qualification Concacaf',
    },
    {
        id: 882,
        name: 'Olympics Women - Qualification Asia',
    },
    {
        id: 883,
        name: 'Reserve League',
    },
    {
        id: 884,
        name: 'Super Cup',
    },
    {
        id: 885,
        name: 'Campeones Cup',
    },
    {
        id: 886,
        name: 'UEFA U17 Championship - Qualification',
    },
    {
        id: 887,
        name: 'Second League - Group A',
    },
    {
        id: 888,
        name: 'Second League - Group B',
    },
    {
        id: 889,
        name: 'Second League - Group C',
    },
    {
        id: 890,
        name: 'U20 Elite League',
    },
    {
        id: 891,
        name: 'Coppa Italia Serie C',
    },
    {
        id: 892,
        name: 'Coppa Italia Serie D',
    },
    {
        id: 893,
        name: 'UEFA U19 Championship - Qualification',
    },
    {
        id: 894,
        name: 'Asian Cup Women - Qualification',
    },
    {
        id: 895,
        name: 'League Cup',
    },
    {
        id: 896,
        name: 'Super Cup',
    },
    {
        id: 897,
        name: 'Asian Cup Women',
    },
    {
        id: 898,
        name: 'League Cup',
    },
    {
        id: 899,
        name: 'League Cup',
    },
    {
        id: 900,
        name: 'Tipsport Malta Cup',
    },
    {
        id: 901,
        name: 'Ykköscup',
    },
    {
        id: 902,
        name: 'Algarve Cup',
    },
    {
        id: 903,
        name: 'The Atlantic Cup',
    },
    {
        id: 904,
        name: 'SheBelieves Cup',
    },
    {
        id: 905,
        name: 'Super Cup',
    },
    {
        id: 906,
        name: 'Reserve League',
    },
    {
        id: 907,
        name: 'Primera Division',
    },
    {
        id: 908,
        name: 'AFF U23 Championship',
    },
    {
        id: 909,
        name: 'MLS Next Pro',
    },
    {
        id: 910,
        name: 'Youth Viareggio Cup',
    },
    {
        id: 911,
        name: 'Southeast Asian Games',
    },
    {
        id: 912,
        name: 'CONCACAF Women U17',
    },
    {
        id: 913,
        name: 'CONMEBOL - UEFA Finalissima',
    },
    {
        id: 914,
        name: 'Tournoi Maurice Revello',
    },
    {
        id: 915,
        name: '1. Division Women',
    },
    {
        id: 916,
        name: 'Kirin Cup',
    },
    {
        id: 917,
        name: 'Copa Ecuador',
    },
    {
        id: 918,
        name: 'UEFA U19 Championship - Women',
    },
    {
        id: 919,
        name: 'Mediterranean Games',
    },
    {
        id: 920,
        name: 'World Cup - U20 - Women',
    },
    {
        id: 921,
        name: 'UEFA U17 Championship',
    },
    {
        id: 922,
        name: 'Africa Cup of Nations - Women',
    },
    {
        id: 923,
        name: 'League 1 Ontario',
    },
    {
        id: 924,
        name: 'Piala Presiden',
    },
    {
        id: 925,
        name: 'Super Cup',
    },
    {
        id: 926,
        name: 'Copa America Femenina',
    },
    {
        id: 927,
        name: 'World Cup - Women - Qualification Concacaf',
    },
    {
        id: 928,
        name: 'AFF U19 Championship',
    },
    {
        id: 929,
        name: 'League Two',
    },
    {
        id: 930,
        name: 'Copa Uruguay',
    },
    {
        id: 931,
        name: 'Non League Premier - Southern Central',
    },
    {
        id: 932,
        name: 'Non League Div One - Northern East',
    },
    {
        id: 933,
        name: 'Non League Div One - Southern Central',
    },
    {
        id: 934,
        name: 'Arab Championship - U20',
    },
    {
        id: 935,
        name: 'Diski Shield',
    },
    {
        id: 936,
        name: 'Catarinense - 2',
    },
    {
        id: 937,
        name: 'Emirates Cup',
    },
    {
        id: 938,
        name: 'Oberliga - Bayern Nord',
    },
    {
        id: 939,
        name: 'Oberliga - Bayern Süd',
    },
    {
        id: 940,
        name: 'COTIF Tournament',
    },
    {
        id: 941,
        name: 'Islamic Solidarity Games',
    },
    {
        id: 942,
        name: 'Serie C - Girone B',
    },
    {
        id: 943,
        name: 'Serie C - Girone C',
    },
    {
        id: 944,
        name: 'Super Cup',
    },
    {
        id: 945,
        name: 'International Champions Cup - Women',
    },
    {
        id: 946,
        name: 'Second NL',
    },
    {
        id: 947,
        name: 'DFB Pokal - Women',
    },
    {
        id: 948,
        name: '1a Divisão - Women',
    },
    {
        id: 949,
        name: 'CONMEBOL Libertadores Femenina',
    },
    {
        id: 950,
        name: 'World Cup - U17 - Women',
    },
    {
        id: 951,
        name: 'South American Youth Games',
    },
    {
        id: 952,
        name: 'AFC U23 Asian Cup - Qualification',
    },
    {
        id: 953,
        name: 'Africa U23 Cup of Nations - Qualification',
    },
    {
        id: 954,
        name: 'National League - Central',
    },
    {
        id: 955,
        name: 'National League - National',
    },
    {
        id: 956,
        name: 'National League - Northern',
    },
    {
        id: 957,
        name: 'National League - Southern',
    },
    {
        id: 958,
        name: 'Copa Costa Rica',
    },
    {
        id: 959,
        name: 'Cup',
    },
    {
        id: 960,
        name: 'Euro Championship - Qualification',
    },
    {
        id: 961,
        name: 'Supercopa',
    },
    {
        id: 962,
        name: 'Premier League',
    },
    {
        id: 963,
        name: 'CONCACAF U17',
    },
    {
        id: 964,
        name: 'Copa de la División Profesional',
    },
];

export const getLeagueName = (leagueId) => {
    return apiFootballLeagues.find((l) => l.id == leagueId)?.name;
};
